import { StyleConstant } from 'util/getStyleConstant';

export default function(attitude) {
  return (
    StyleConstant[`ATTITUDE_COLORS_${attitude}`] ||
    StyleConstant['ATTITUDE_COLORS_UNKNOWN']
  );
}
